module.exports = __webpack_public_path__ + "img/lucky.c58320f0.png";